import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from "react-router-dom";
import { put } from '../../utils/api';
import { Form, FormLine, FormItem, FormInput } from '../common/Form';
import './ExhibitorEditTexts.css';
import Translator from '../common/Translator';
const LIMIT_SHORT = 150;
const LIMIT_LONG  = 600;
//
// Редактирование brief, about, descr
//
const ExhibitorEditTexts = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
    const exhibitor = useSelector(state => state.exhibitor);
	const [ briefRu, setBriefRu ] = useState(exhibitor.brief.ru);
	const [ briefEn, setBriefEn ] = useState(exhibitor.brief.en);
	const [ aboutRu, setAboutRu ] = useState(exhibitor.about.ru);
	const [ aboutEn, setAboutEn ] = useState(exhibitor.about.en);
	const [ descrRu, setDescrRu ] = useState(exhibitor.descr.ru);
	const [ descrEn, setDescrEn ] = useState(exhibitor.descr.en);
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');
    const [ isTranslating, setIsTranslating ] = useState(false);

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');
        setSuccess('');

        const data = {};
        data.brief_ru = briefRu;
        data.brief_en = briefEn;
        data.about_ru = aboutRu;
        data.about_en = aboutEn;
        data.descr_ru = descrRu + ' ';
        data.descr_en = descrEn + ' ';

        const result = await put('/exhibitors/' + exhibitor._id, data);

        if(result.error) {
            setSaveError(result.error);
        } else {
            setSuccess('exhibitoredit.success');
			navigate('/cabinet/exhibitorview/' + exhibitor._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{t('exhibitoredit.title_texts')}</h1>
			{isSaving ? <span>{t('common.loading')}</span> :
			<Form
                success={success}
                error={saveError}
                info={'exhibitoredit.subtitle'}
                wide={true}
                submit={isTranslating ? '' : t('common.save_changes')}
                onSubmit={onSubmit}
            >
            
                <h2>{t('exhibitorview.brief')}</h2>
                <p>{t('exhibitoredit.brief_hint')}</p>
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='briefRu'
                            type='textarea'
                            limit={LIMIT_SHORT}
                            value={briefRu}
                            onChange={setBriefRu}
                            placeholder={t('exhibitoredit.brief_ru')}
                            label={t('exhibitoredit.brief_ru')}
                            className='lang-ru'
                            required={true}
                            hint={<Translator current={briefRu} text={briefEn} from='en' limit={LIMIT_SHORT} setText={setBriefRu} setIsTranslating={setIsTranslating}/>}
                            disabled={isTranslating}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='briefEn'
                            type='textarea'
                            limit={LIMIT_SHORT}
                            value={briefEn}
                            onChange={setBriefEn}
                            placeholder={t('exhibitoredit.brief_en')}
                            label={t('exhibitoredit.brief_en')}
                            className='lang-en'
                            required={true}
                            hint={<Translator current={briefEn} text={briefRu} from='ru' limit={LIMIT_SHORT} setText={setBriefEn} setIsTranslating={setIsTranslating}/>}
                            disabled={isTranslating}
                        />
                    </FormItem>
                </FormLine>

                <h2>{t('exhibitorview.about')}</h2>
                <p>{t('exhibitoredit.about_hint')}</p>
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='aboutRu'
                            type='textarea'
                            limit={LIMIT_LONG}
                            value={aboutRu}
                            onChange={setAboutRu}
                            placeholder={t('exhibitoredit.about_ru')}
                            label={t('exhibitoredit.about_ru')}
                            className='lang-ru'
                            required={true}
                            hint={<Translator current={aboutRu} text={aboutEn} from='en' limit={LIMIT_LONG} setText={setAboutRu} setIsTranslating={setIsTranslating}/>}
                            disabled={isTranslating}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='aboutEn'
                            type='textarea'
                            limit={LIMIT_LONG}
                            value={aboutEn}
                            onChange={setAboutEn}
                            placeholder={t('exhibitoredit.about_en')}
                            label={t('exhibitoredit.about_en')}
                            className='lang-en'
                            required={true}
                            hint={<Translator current={aboutEn} text={aboutRu} from='ru' limit={LIMIT_LONG} setText={setAboutEn} setIsTranslating={setIsTranslating}/>}
                            disabled={isTranslating}
                        />
                    </FormItem>
                </FormLine>

                <h2>{t('exhibitorview.descr')}</h2>
                <p>{t('exhibitoredit.descr_hint')}</p>
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='descrRu'
                            type='textarea'
                            limit={LIMIT_LONG}
                            value={descrRu}
                            onChange={setDescrRu}
                            placeholder={t('exhibitoredit.descr_ru')}
                            label={t('exhibitoredit.descr_ru')}
                            className='lang-ru'
                            hint={<Translator current={descrRu} text={descrEn} from='en' limit={LIMIT_LONG} setText={setDescrRu} setIsTranslating={setIsTranslating}/>}
                            disabled={isTranslating}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='descrEn'
                            type='textarea'
                            limit={LIMIT_LONG}
                            value={descrEn}
                            onChange={setDescrEn}
                            placeholder={t('exhibitoredit.descr_en')}
                            label={t('exhibitoredit.descr_en')}
                            className='lang-en'
                            hint={<Translator current={descrEn} text={descrRu} from='ru' limit={LIMIT_LONG} setText={setDescrEn} setIsTranslating={setIsTranslating}/>}
                            disabled={isTranslating}
                        />
                    </FormItem>
                </FormLine>
			</Form>}

            <NavLink to={'/cabinet/exhibitorview/' + exhibitor._id}>
                {t('exhibitoredit.back')}
            </NavLink>
		</div>
	);
};

export default ExhibitorEditTexts;
